import React, { useEffect, useState } from 'react'
import { FiMapPin, FiArrowRight, FiPhone, FiClock } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import { getSettings } from '../../services/api'

const Hero = () => {
  const [contactInfo, setContactInfo] = useState({
    phone: '+56 9 3292 1831',
    address: 'Concepción, Chile'
  })

  useEffect(() => {
    getSettings().then(res => {
      const d = res.data || {}
      setContactInfo(prev => ({
        ...prev,
        phone: d.contact_phone || prev.phone,
        address: d.contact_address || prev.address
      }))
    }).catch(console.error)
  }, [])

  const metaCards = [
    {
      icon: FiPhone,
      label: 'Contacto directo',
      value: contactInfo.phone,
    },
    {
      icon: FiMapPin,
      label: 'Estamos en',
      value: contactInfo.address,
    },
    {
      icon: FiClock,
      label: 'Horarios',
      value: 'Lun a Vie · 09:00 a 20:00',
    },
  ]
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-white via-primary-50/60 to-blue-50 py-16 sm:py-20 lg:py-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-y-0 right-[-15%] hidden h-[140%] w-[55%] max-w-2xl rounded-full bg-primary-200/40 blur-3xl md:block"
      />

      <div className="relative mx-auto flex max-w-7xl flex-col gap-12 px-4 sm:px-6 lg:px-8">
        <span className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600">
          Centro integral de salud mental
        </span>

        <div className="flex flex-col gap-12 lg:flex-row lg:items-start">
          <div className="max-w-3xl space-y-8 text-neutral-900">
            <div className="space-y-6">
              <h1 className="text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
                Recupera tu equilibrio emocional con un equipo que acompaña cada paso
              </h1>
              <p className="text-base leading-relaxed text-neutral-600 sm:text-lg">
                Terapias presenciales y online con profesionales certificados. Diseñamos planes personalizados que combinan contención, tratamiento y seguimiento continuo.
              </p>
            </div>

            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
              <Link
                to="/reservar/servicios"
                className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary-500 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-primary-200 focus:ring-offset-2 no-underline hover:no-underline"
              >
                Reservar tu primera sesión
                <FiArrowRight className="h-4 w-4" />
              </Link>
              <span className="text-sm text-neutral-500 sm:order-last sm:ml-2">
                Agenda en menos de 2 minutos. Cancelación flexible.
              </span>
              <Link
                to="/equipo"
                className="inline-flex items-center justify-center gap-2 rounded-lg border border-neutral-200 bg-white px-5 py-3 text-sm font-semibold text-neutral-900 shadow-sm transition hover:border-primary-200 hover:text-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-200 focus:ring-offset-2 no-underline hover:no-underline"
              >
                Conoce al equipo
              </Link>
            </div>
          </div>

          <div className="grid w-full max-w-sm gap-3 self-start rounded-2xl border border-neutral-200 bg-white/70 p-6 shadow-sm backdrop-blur lg:max-w-xs">
            {metaCards.map(({ icon: Icon, label, value }) => (
              <div
                key={label}
                className="flex items-center gap-3 rounded-xl border border-neutral-200 bg-white p-4 shadow-sm"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-50 text-primary-600">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <span className="text-xs font-semibold uppercase tracking-wide text-neutral-500">{label}</span>
                  <p className="text-sm font-semibold text-neutral-900">{value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
